import { put, select, takeEvery } from 'redux-saga/effects';
import actions from '../actions';
import selectors from '../selectors';
import { comparePlayProgress, getNextPlaybookPage, getPreviousPlaybookPage } from '../models';
import { generatePathFromPlaybookPage } from '../utils/routerUtils';
import { IPlaybookPage, ITour, ITourProgress } from '../../../models';
import { getServiceProvider, IServiceProvider } from '../../../services';
import { ActionType } from '../../../utils/reduxUtils';

const navigateRequestSaga = takeEvery(actions.navigatePage.request.type, function* (
  action: ActionType<typeof actions.navigatePage.request>
) {
  const serviceProvider: IServiceProvider = yield getServiceProvider();
  const { params, direction } = action.payload;

  const [tour, runningTour]: [ITour, ITourProgress] = yield select(selectors.selectTourAndTourProgress, params);
  const requestedPage: IPlaybookPage = yield select(selectors.selectPlaybookPage, params);

  const page =
    direction === 'next'
      ? getNextPlaybookPage(tour.stops, requestedPage)
      : getPreviousPlaybookPage(tour.stops, requestedPage);
  if (page && runningTour?.playbook) {
    if (comparePlayProgress(page, runningTour.playbook.currentPage) > 0) {
      yield put(actions.navigatePage.update({ tourCode: tour.shortLink!, nextPage: page }));
    }
    const path = generatePathFromPlaybookPage(serviceProvider.navigationService, tour.shortLink!, page);
    serviceProvider.navigationService.navigate(path);
  }
});

const sagas = [navigateRequestSaga];

export default sagas;
